export default {
 __isHandRaised: false,
 self_name: '',
 connected: undefined,
 roomId: undefined,
 selfId: undefined,
 gallery: false,
 tips: {
  "mute_local_audio": [ "tooltip_mute_audio", "tooltip_unmute_audio" ],
  "mute_local_video": [ "tooltip_mute_video", "tooltip_unmute_video" ],
  "raise_hand": [ "tooltip_raise_hand", "tooltip_drop_hand" ],
  "btn_stats": [ "tooltip_show_stats", "tooltip_hide_stats" ],
  "btn_settings": [ "tooltip_settings" ],
  "btn_share_screen": [ "tooltip_share_screen_start", "tooltip_share_screen_stop" ],
  "btn_text_chat": [ "tooltip_open_chat", "tooltip_close_chat" ],
  "btn_gallery_view": [ "tooltip_switch_gallery_view", "tooltip_switch_active_view" ],
  "btn_quality": [ "tooltip_quality" ],
  "btn_more": [ "tooltip_more" ]
 },
 tips_bottom: {
  "btn_leave_room": [ "tooltip_leave_room" ],
  "room_details_container": [ "tooltip_url_to_clipboard" ],
  "btn_language": [ "tooltip_language" ]
 }
};
/* vim:set sw=1 ts=8 expandtab: */
